// LineHeightIcon.tsx

import React from "react";

export const LineHeightIcon: React.FC<React.SVGProps<SVGSVGElement>> = (props) => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none" {...props}>
      <line x1="0.44873" y1="15.4528" x2="15.5519" y2="15.4528" stroke="currentColor" strokeWidth="0.336587" />

      <line x1="0.44873" y1="0.847332" x2="15.5519" y2="0.847332" stroke="currentColor" strokeWidth="0.336587" />

      <path
        d="M10.5304 11.2015L9.87538 9.55852H6.1231L5.46811 11.2015H4.44678L7.42196 3.79688H8.56541L11.5517 11.2015H10.5304ZM7.99924 4.61838L6.38953 8.73702H9.59785L7.99924 4.61838Z"
        fill="currentColor"
      />
    </svg>
  );
};
